// Complete pre-order form for Shopify
// Global state and functions defined immediately to avoid timing issues
(function() {
  'use strict';

  console.log('Pre-order form script loaded');

  // Global state object - defined immediately
  const globalState = {
    selectedVariantId: null,
    selectedColor: '',
    selectedSize: '',
    selectedDelivery: 'standard',
    quantity: 1,
    basePrice: 0,
    variantImageMap: {},
    variantIdMap: {},
    config: null,
    variantOptionNames: [],
    initialized: false
  };

  // Define all interactive functions in global scope immediately
  // This prevents "function is not defined" errors from onclick handlers
  
  window.selectColor = function(element) {
    console.log('=== selectColor called ===');
    
    if (!element || !element.dataset) {
      console.error('Invalid element passed to selectColor');
      return;
    }
    
    try {
      // Remove selection from all swatches
      document.querySelectorAll('.color-swatch').forEach(s => {
        s.classList.remove('selected');
        s.style.borderColor = 'transparent';
        s.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
      });
      
      // Add selection to clicked swatch
      element.classList.add('selected');
      element.style.borderColor = '#000000';
      element.style.boxShadow = '0 0 0 2px #ffffff, 0 0 0 4px #000000';
      
      const colorName = element.dataset.colorName;
      globalState.selectedColor = colorName;
      
      // Update variant ID based on selected color
      if (globalState.variantIdMap[colorName]) {
        globalState.selectedVariantId = globalState.variantIdMap[colorName];
        console.log('Updated variant ID to:', globalState.selectedVariantId);
      }
      
      // Hide color error
      const colorError = document.getElementById('colorError');
      if (colorError) {
        colorError.classList.add('hidden');
      }
      
      // Show selected color name
      const selectedColorNameDiv = document.getElementById('selectedColorName');
      const selectedColorText = document.getElementById('selectedColorText');
      if (selectedColorNameDiv && selectedColorText) {
        selectedColorText.textContent = colorName;
        selectedColorNameDiv.style.display = 'block';
      }
      
      // Change main image if variant image exists
      const variantImage = globalState.variantImageMap[colorName];
      if (variantImage) {
        const mainImage = document.getElementById('mainImage');
        if (mainImage) {
          mainImage.src = variantImage;
          console.log('Changed main image to variant image:', variantImage);
        }
      }
      
      console.log('Color selected:', colorName);
      console.log('=== selectColor completed ===');
    } catch (error) {
      console.error('Error in selectColor:', error);
    }
  };

  window.selectSize = function(element, size) {
    console.log('=== selectSize called ===');
    
    if (!element || !size) {
      console.error('Invalid parameters passed to selectSize');
      return;
    }
    
    try {
      document.querySelectorAll('.size-option').forEach(s => s.classList.remove('selected'));
      element.classList.add('selected');
      
      globalState.selectedSize = size;
      
      const selectedSizeInput = document.getElementById('selectedSize');
      if (selectedSizeInput) {
        selectedSizeInput.value = size;
      }
      
      const sizeError = document.getElementById('sizeError');
      if (sizeError) {
        sizeError.classList.add('hidden');
      }
      
      console.log('Size selected:', size);
      console.log('=== selectSize completed ===');
    } catch (error) {
      console.error('Error in selectSize:', error);
    }
  };

  window.selectDelivery = function(element, type) {
    console.log('=== selectDelivery called ===');
    console.log('Type:', type);
    console.log('Previous globalState.selectedDelivery:', globalState.selectedDelivery);
    
    if (!element || !type || !globalState.config) {
      console.error('Invalid parameters or config not loaded');
      return;
    }
    
    try {
      document.querySelectorAll('.delivery-option').forEach(d => d.classList.remove('selected'));
      element.classList.add('selected');
      
      // Update state
      globalState.selectedDelivery = type;
      console.log('Updated globalState.selectedDelivery:', globalState.selectedDelivery);
      
      // Get delivery information
      const standardOption = document.getElementById('standardDeliveryOption');
      const expressOption = document.getElementById('expressDeliveryOption');
      
      if (!standardOption || !expressOption) {
        console.error('Delivery option elements not found');
        return;
      }
      
      const deliveryName = type === 'standard' ? 
        standardOption.querySelector('.font-medium').textContent :
        expressOption.querySelector('.font-medium').textContent;
      
      const standardDateRange = document.getElementById('standardDateRange');
      const expressDateRange = document.getElementById('expressDateRange');
      
      const deliveryDateRange = type === 'standard' ?
        (standardDateRange ? standardDateRange.textContent : '') :
        (expressDateRange ? expressDateRange.textContent : '');
      
      // Calculate delivery fee based on type
      let deliveryFee = 0;
      if (type === 'express') {
        deliveryFee = globalState.config.expressFee || 0;
        console.log('Express delivery selected, fee:', deliveryFee);
      } else if (type === 'standard' && globalState.config.standardDeliveryFee > 0) {
        deliveryFee = globalState.config.standardDeliveryFee;
        console.log('Standard delivery selected, fee:', deliveryFee);
      } else {
        console.log('Standard delivery selected, no fee');
      }
      
      // Format delivery property with fee information
      let deliveryProperty = `【${deliveryName}・納期(${deliveryDateRange})】`;
      if (deliveryFee > 0) {
        const feeFormatted = (deliveryFee / 100).toLocaleString('ja-JP');
        deliveryProperty += `+${feeFormatted}円`;
      }
      
      console.log('Formatted delivery property:', deliveryProperty);
      
      // Remove ALL existing delivery-related hidden inputs to avoid duplicates
      const form = document.getElementById('preOrderForm');
      if (form) {
        // Remove any input with name containing delivery-related keywords
        const existingInputs = form.querySelectorAll('input[type="hidden"]');
        existingInputs.forEach(input => {
          const inputName = input.name || '';
          const inputValue = input.value || '';
          // Check if name or value contains delivery-related keywords
          if (inputName.includes('配送') || inputName.includes('お届け') || 
              inputValue.includes('配送') || inputValue.includes('お届け') ||
              inputName.includes('delivery') || inputName.includes('shipping')) {
            console.log('Removing existing delivery-related input:', inputName, '=', inputValue);
            input.remove();
          }
        });
      }
      
      // Create new hidden input for delivery option
      const deliveryInput = document.createElement('input');
      deliveryInput.type = 'hidden';
      deliveryInput.id = 'selectedDelivery';
      deliveryInput.name = 'properties[配送オプション]';
      deliveryInput.value = deliveryProperty;
      
      if (form) {
        form.appendChild(deliveryInput);
        console.log('Created new hidden input: 配送オプション =', deliveryProperty);
      }
      
      // Update minimum date and total price
      if (typeof updateMinDate === 'function') updateMinDate();
      if (typeof updateTotalPrice === 'function') updateTotalPrice();
      
      console.log('=== selectDelivery completed ===');
    } catch (error) {
      console.error('Error in selectDelivery:', error);
    }
  };

  window.updateQuantity = function(change) {
    console.log('=== updateQuantity called ===');
    console.log('Change:', change);
    
    try {
      const quantityInput = document.getElementById('quantity');
      if (!quantityInput) {
        console.error('Quantity input not found');
        return;
      }
      
      let newQuantity = parseInt(quantityInput.value) + change;
      
      if (newQuantity < 1) newQuantity = 1;
      
      quantityInput.value = newQuantity;
      globalState.quantity = newQuantity;
      
      if (typeof updateTotalPrice === 'function') {
        updateTotalPrice();
      }
      
      console.log('Quantity updated to:', newQuantity);
      console.log('=== updateQuantity completed ===');
    } catch (error) {
      console.error('Error in updateQuantity:', error);
    }
  };

  window.changeMainImage = function(imageUrl, thumbnail) {
    console.log('=== changeMainImage called ===');
    
    if (!imageUrl || !thumbnail) {
      console.error('Invalid parameters passed to changeMainImage');
      return;
    }
    
    try {
      const mainImage = document.getElementById('mainImage');
      if (mainImage) {
        mainImage.src = imageUrl;
      }
      
      document.querySelectorAll('.thumbnail-container').forEach(t => {
        t.classList.remove('thumbnail-active');
        t.classList.add('thumbnail-inactive');
      });
      
      thumbnail.classList.remove('thumbnail-inactive');
      thumbnail.classList.add('thumbnail-active');
      
      console.log('Main image changed to:', imageUrl);
      console.log('=== changeMainImage completed ===');
    } catch (error) {
      console.error('Error in changeMainImage:', error);
    }
  };

  // Helper function to update minimum date
  function updateMinDate() {
    try {
      const dateInput = document.getElementById('usageDate');
      if (!dateInput || !globalState.config) return;
      
      const today = new Date();
      const minDays = globalState.selectedDelivery === 'standard' ? 
        globalState.config.standardMaxDays : 
        globalState.config.expressMaxDays;
      
      today.setDate(today.getDate() + minDays);
      const minDate = today.toISOString().split('T')[0];
      dateInput.min = minDate;
      
      if (dateInput.value && dateInput.value < minDate) {
        dateInput.value = minDate;
      }
      
      console.log('Minimum date updated to:', minDate);
    } catch (error) {
      console.error('Error in updateMinDate:', error);
    }
  }

  // Helper function to update total price
  function updateTotalPrice() {
    try {
      if (!globalState.config) {
        console.warn('Config not loaded, cannot update price');
        return;
      }
      
      let total = globalState.basePrice * globalState.quantity;
      
      console.log('=== updateTotalPrice ===');
      console.log('Base price:', globalState.basePrice);
      console.log('Quantity:', globalState.quantity);
      console.log('Selected delivery:', globalState.selectedDelivery);
      
      // Add delivery fee based on selection
      if (globalState.selectedDelivery === 'express') {
        total += globalState.config.expressFee || 0;
        console.log('Adding express fee:', globalState.config.expressFee);
      } else if (globalState.selectedDelivery === 'standard' && globalState.config.standardDeliveryFee > 0) {
        total += globalState.config.standardDeliveryFee;
        console.log('Adding standard delivery fee:', globalState.config.standardDeliveryFee);
      } else {
        console.log('No delivery fee added');
      }
      
      const formattedPrice = (total / 100).toLocaleString('ja-JP');
      
      const currentPriceEl = document.getElementById('currentPrice');
      const totalPriceEl = document.getElementById('totalPrice');
      
      if (currentPriceEl) currentPriceEl.textContent = formattedPrice;
      if (totalPriceEl) totalPriceEl.textContent = formattedPrice;
      
      console.log('Total:', total, 'Formatted:', formattedPrice);
      console.log('=== updateTotalPrice completed ===');
    } catch (error) {
      console.error('Error in updateTotalPrice:', error);
    }
  }
  
  // Make updateTotalPrice available globally
  window.updateTotalPrice = updateTotalPrice;

  // Format date as Japanese format (MM月DD日)
  function formatJapaneseDate(date) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${month}月${day}日`;
  }

  // Update delivery dates
  function updateDeliveryDates() {
    try {
      if (!globalState.config) {
        console.warn('Config not loaded, cannot update delivery dates');
        return;
      }
      
      const today = new Date();
      
      // Standard delivery dates
      const standardMinDate = new Date(today);
      standardMinDate.setDate(standardMinDate.getDate() + globalState.config.standardMinDays);
      const standardMaxDate = new Date(today);
      standardMaxDate.setDate(standardMaxDate.getDate() + globalState.config.standardMaxDays);
      
      const standardDateRangeEl = document.getElementById('standardDateRange');
      if (standardDateRangeEl) {
        standardDateRangeEl.textContent = `${formatJapaneseDate(standardMinDate)}〜${formatJapaneseDate(standardMaxDate)}`;
      }
      
      // Express delivery dates
      const expressMinDate = new Date(today);
      expressMinDate.setDate(expressMinDate.getDate() + globalState.config.expressMinDays);
      const expressMaxDate = new Date(today);
      expressMaxDate.setDate(expressMaxDate.getDate() + globalState.config.expressMaxDays);
      
      const expressDateRangeEl = document.getElementById('expressDateRange');
      if (expressDateRangeEl) {
        expressDateRangeEl.textContent = `${formatJapaneseDate(expressMinDate)}〜${formatJapaneseDate(expressMaxDate)}`;
      }
      
      console.log('Delivery dates updated');
    } catch (error) {
      console.error('Error in updateDeliveryDates:', error);
    }
  }

  // Validate form
  function validateForm() {
    console.log('=== Validating form ===');
    let isValid = true;
    const errors = [];
    
    try {
      // Color validation
      if (!globalState.selectedColor) {
        const colorError = document.getElementById('colorError');
        if (colorError) {
          colorError.classList.remove('hidden');
          colorError.style.color = '#dc2626';
          colorError.style.fontWeight = 'bold';
          colorError.style.fontSize = '14px';
          colorError.style.marginTop = '8px';
        }
        errors.push('カラーを選択してください');
        isValid = false;
        console.error('Validation failed: Color not selected');
      }
      
      // Size validation
      if (!globalState.selectedSize) {
        const sizeError = document.getElementById('sizeError');
        if (sizeError) {
          sizeError.classList.remove('hidden');
        }
        errors.push('サイズを選択してください');
        isValid = false;
        console.error('Validation failed: Size not selected');
      }
      
      // Date validation
      const usageDate = document.getElementById('usageDate');
      if (usageDate && !usageDate.value) {
        const dateError = document.getElementById('dateError');
        if (dateError) {
          dateError.classList.remove('hidden');
        }
        errors.push('ご利用日を選択してください');
        isValid = false;
        console.error('Validation failed: Usage date not selected');
      }
      
      // Usage scene validation
      const usageScene = document.getElementById('usageScene');
      if (usageScene && !usageScene.value) {
        const sceneError = document.getElementById('sceneError');
        if (sceneError) {
          sceneError.classList.remove('hidden');
        }
        errors.push('ご利用シーンを選択してください');
        isValid = false;
        console.error('Validation failed: Usage scene not selected');
      }
      
      // Policy validation
      const policyAgree = document.getElementById('policyAgree');
      if (policyAgree && !policyAgree.checked) {
        const policyError = document.getElementById('policyError');
        if (policyError) {
          policyError.classList.remove('hidden');
        }
        errors.push('利用規約に同意してください');
        isValid = false;
        console.error('Validation failed: Policy not agreed');
      }
      
      // Show alert with all errors
      if (!isValid) {
        const errorMessage = '以下の項目を確認してください:\n\n' + errors.join('\n');
        alert(errorMessage);
        console.error('Form validation failed with errors:', errors);
      } else {
        console.log('Form validation passed');
      }
      
      console.log('Current globalState:', globalState);
      console.log('=== Validation completed ===');
    } catch (error) {
      console.error('Error in validateForm:', error);
      isValid = false;
    }
    
    return isValid;
  }

  // Add to cart
  async function addToCart(event) {
    event.preventDefault();
    
    console.log('=== Form submitted ===');
    console.log('Current globalState:', globalState);
    
    if (!validateForm()) {
      console.log('Form validation failed - stopping submission');
      return;
    }
    
    const button = document.getElementById('addToCartBtn');
    if (!button) {
      console.error('Add to cart button not found');
      return;
    }
    
    const originalHTML = button.innerHTML;
    button.disabled = true;
    button.innerHTML = '<i class="ph ph-spinner ph-spin text-xl"></i><span>追加中...</span>';
    
    try {
      const formData = new FormData(event.target);
      
      // Prepare product data
      const productData = {
        id: globalState.selectedVariantId,
        quantity: globalState.quantity,
        properties: {}
      };
      
      console.log('Variant ID:', globalState.selectedVariantId);
      console.log('Quantity:', globalState.quantity);
      
      // Get the delivery property from hidden input - ONLY source for delivery info
      const deliveryInput = document.getElementById('selectedDelivery');
      if (deliveryInput && deliveryInput.value) {
        productData.properties['配送オプション'] = deliveryInput.value;
        console.log('✓ Delivery property added from hidden input:', deliveryInput.value);
      } else {
        console.error('❌ No delivery input found!');
      }
      
      // Add form properties - STRICTLY filter out ALL delivery-related properties
      for (let [key, value] of formData.entries()) {
        if (key.startsWith('properties[') && key !== 'quantity') {
          const propName = key.match(/properties\[(.*?)\]/)[1];
          
          // CRITICAL: Skip ALL delivery-related properties from form
          // We ONLY use the delivery property from the hidden input above
          if (propName.includes('配送') || propName.includes('お届け') || 
              propName.includes('delivery') || propName.includes('shipping') ||
              propName === '配送オプション' || propName === '配送' ||
              propName.includes('お取り寄せ') || propName.includes('速達')) {
            console.log(`❌ SKIPPED delivery property from form: "${propName}" = "${value}"`);
            continue;
          }
          
          // Skip properties that match variant option names
          if (globalState.variantOptionNames.includes(propName)) {
            console.log(`❌ SKIPPED variant option: "${propName}"`);
            continue;
          }
          
          // Skip empty values
          if (value && value.trim() !== '') {
            productData.properties[propName] = value;
            console.log(`✓ Added property: ${propName} = ${value}`);
          }
        }
      }
      
      console.log('========================================');
      console.log('FINAL PRODUCT DATA TO SEND TO CART:');
      console.log(JSON.stringify(productData, null, 2));
      console.log('========================================');
      
      // Add to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(productData)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        console.error('Cart add error response:', errorData);
        throw new Error(errorData.description || 'カートへの追加に失敗しました');
      }
      
      const result = await response.json();
      console.log('Cart add result:', result);
      console.log('=== Cart add successful ===');
      
      // Redirect to cart
      window.location.href = '/cart';
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('カートへの追加中にエラーが発生しました。もう一度お試しください。\n\nエラー: ' + error.message);
      button.disabled = false;
      button.innerHTML = originalHTML;
    }
  }

  // Initialize the app
  function initApp() {
    console.log('=== Initializing pre-order form ===');
    
    try {
      // Get product data from JSON script tag
      const productDataJson = document.getElementById('product-data-json');
      if (!productDataJson) {
        console.error('Product data JSON not found');
        return;
      }

      let config;
      try {
        config = JSON.parse(productDataJson.textContent);
        globalState.config = config;
        console.log('Product config loaded:', config);
      } catch (error) {
        console.error('Error parsing product data:', error);
        return;
      }

      // Get variant option names to avoid duplicates
      globalState.variantOptionNames = config.options.map(opt => opt.name);
      console.log('Variant option names:', globalState.variantOptionNames);

      // Initialize state
      globalState.selectedVariantId = config.variantId;
      globalState.basePrice = config.basePrice;
      globalState.quantity = 1;
      
      console.log('Initial globalState:', globalState);

      // Build variant maps
      if (config.variants && config.variants.length > 0) {
        config.variants.forEach(variant => {
          if (variant.option1) {
            if (variant.featured_image) {
              globalState.variantImageMap[variant.option1] = variant.featured_image;
            }
            globalState.variantIdMap[variant.option1] = variant.id;
          }
        });
        console.log('Variant image map:', globalState.variantImageMap);
        console.log('Variant ID map:', globalState.variantIdMap);
      }

      // Parse colors
      let colorMap = {};
      let colors = [];
      
      const colorOption = config.options.find(opt => opt.position === 1);
      if (colorOption && colorOption.values && colorOption.values.length > 0) {
        colors = colorOption.values;
        console.log('Using colors from product variants:', colors);
        
        // Build color map
        colors.forEach(color => {
          const colorLower = color.toLowerCase();
          if (colorLower.includes('アイボリー') || colorLower.includes('ivory')) {
            colorMap[color] = '#FFFFF0';
          } else if (colorLower.includes('ホワイト') || colorLower.includes('white')) {
            colorMap[color] = '#FFFFFF';
          } else if (colorLower.includes('ブラック') || colorLower.includes('black')) {
            colorMap[color] = '#000000';
          } else if (colorLower.includes('レッド') || colorLower.includes('red')) {
            colorMap[color] = '#FF0000';
          } else if (colorLower.includes('ブルー') || colorLower.includes('blue')) {
            colorMap[color] = '#0000FF';
          } else if (colorLower.includes('グリーン') || colorLower.includes('green')) {
            colorMap[color] = '#008000';
          } else if (colorLower.includes('イエロー') || colorLower.includes('yellow')) {
            colorMap[color] = '#FFFF00';
          } else if (colorLower.includes('ピンク') || colorLower.includes('pink')) {
            colorMap[color] = '#FFC0CB';
          } else if (colorLower.includes('パープル') || colorLower.includes('purple')) {
            colorMap[color] = '#800080';
          } else {
            colorMap[color] = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
          }
        });
      }
      
      // Fallback to custom colors
      if (colors.length === 0 && config.customColors) {
        console.log('Using custom colors from section settings:', config.customColors);
        const customColorPairs = config.customColors.split(',');
        customColorPairs.forEach(pair => {
          const [name, code] = pair.split(':').map(s => s.trim());
          if (name && code) {
            colors.push(name);
            colorMap[name] = code;
          }
        });
      }
      
      console.log('Final colors:', colors);
      console.log('Color map:', colorMap);

      // Populate color swatches
      const colorSwatchesContainer = document.getElementById('colorSwatches');
      if (colorSwatchesContainer && colors.length > 0) {
        colorSwatchesContainer.innerHTML = '';
        
        colors.forEach((color, index) => {
          const swatch = document.createElement('div');
          swatch.className = 'color-swatch';
          swatch.dataset.colorName = color;
          swatch.title = color;
          swatch.onclick = function() { window.selectColor(this); };
          
          const variantImage = globalState.variantImageMap[color];
          
          if (variantImage) {
            swatch.style.backgroundImage = `url(${variantImage})`;
            swatch.style.backgroundSize = 'cover';
            swatch.style.backgroundPosition = 'center';
          } else {
            const bgColor = colorMap[color];
            if (bgColor && bgColor.startsWith('linear-gradient')) {
              swatch.style.backgroundImage = bgColor;
            } else {
              swatch.style.backgroundColor = bgColor || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
            }
          }
          
          swatch.style.width = '56px';
          swatch.style.height = '56px';
          swatch.style.borderRadius = '50%';
          swatch.style.border = '3px solid transparent';
          swatch.style.cursor = 'pointer';
          swatch.style.transition = 'all 0.3s ease';
          swatch.style.display = 'inline-block';
          swatch.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
          
          colorSwatchesContainer.appendChild(swatch);
        });
        
        console.log('Color swatches populated:', colors.length);
        
        // Auto-select first color
        const firstSwatch = colorSwatchesContainer.querySelector('.color-swatch');
        if (firstSwatch) {
          window.selectColor(firstSwatch);
          console.log('Auto-selected first color:', colors[0]);
        }
      }

      // Initialize delivery dates
      updateDeliveryDates();

      // Initialize defaults
      updateMinDate();
      updateTotalPrice();
      
      // Initialize default delivery option
      const standardDeliveryElement = document.getElementById('standardDeliveryOption');
      if (standardDeliveryElement) {
        window.selectDelivery(standardDeliveryElement, 'standard');
        console.log('Default delivery option initialized: standard');
      }

      // Form submission handler
      const form = document.getElementById('preOrderForm');
      if (form) {
        form.addEventListener('submit', addToCart);
        console.log('Form submit handler attached');
      }

      // Quantity input change handler
      const quantityInput = document.getElementById('quantity');
      if (quantityInput) {
        quantityInput.addEventListener('change', function() {
          globalState.quantity = parseInt(this.value) || 1;
          if (globalState.quantity < 1) {
            globalState.quantity = 1;
            this.value = 1;
          }
          updateTotalPrice();
        });
      }

      globalState.initialized = true;
      console.log('=== Pre-order form initialized successfully ===');
      
    } catch (error) {
      console.error('Error initializing app:', error);
    }
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApp);
  } else {
    initApp();
  }
})();